import moment from 'dayjs';

export const getEmbedUrl = (videoUrl: string): string => {
  return videoUrl && /youtube|youtu\.be/.test(videoUrl)
    ? `https://www.youtube.com/embed/${
        videoUrl.includes('youtu.be')
          ? videoUrl.split('/')[3]
          : videoUrl.split('=')[1]
      }`
    : videoUrl;
};

export const isPastTimeline = (startDate: string, includeStartDate = true) => {
  const currTimestamp = new Date();
  const currentDate = currTimestamp.setHours(0, 0, 0, 0);
  const start = moment(startDate).startOf('day').unix() * 1000;
  return includeStartDate ? start <= currentDate : start < currentDate;
};
